const values = [
  "ShowcaseLightSpells",
  "ShowcaseLightTowers",
  "ShowcasePremium",
  "ShowcaseWaterHeroes",
  "ShowcaseWaterSpells",
  "ShowcaseWaterTowers",
];
export default values;
